<template>
	<!-- 外层ul控制卡片范围 -->
	<div>
		<div
			class="point"
			ref="point"
			:class="{ show: show }"
			:style="`left:${moveLeft}px;top:${moveTop}px;`"
			@touchstart="dragStart"
			@touchend="dragEnd"
			@touchmove.prevent="dragMove"
		>
			<div class="flexBox" style="width: 111px; height: 111px">
				<template v-if="!open">
					<img src="@/assets/images/aiIcon.png" class="aiBtn" @click.stop="goAi" />
					<svg style="transform: scale(0.9)" width="111px" height="111px" @click.stop="open = true">
						<defs>
							<!-- <filter filterUnits="userSpaceOnUse" id="Filter_0" x="0px" y="0px" width="111px" height="111px">
								<feOffset in="SourceAlpha" dx="0" dy="0" />
								<feGaussianBlur result="blurOut" stdDeviation="5.099" />
								<feFlood flood-color="rgb(122, 14, 113)" result="floodOut" />
								<feComposite operator="atop" in="floodOut" in2="blurOut" />
								<feComponentTransfer><feFuncA type="linear" slope="0.4" /></feComponentTransfer>
								<feMerge>
									<feMergeNode />
									<feMergeNode in="SourceGraphic" />
								</feMerge>
							</filter>
							<filter id="Filter_1">
								<feOffset in="SourceAlpha" dx="-0.651" dy="1.891" />
								<feGaussianBlur result="blurOut" stdDeviation="3.606" />
								<feFlood flood-color="rgb(255, 255, 255)" result="floodOut" />
								<feComposite operator="out" in="floodOut" in2="blurOut" result="compOut" />
								<feComposite operator="in" in="compOut" in2="SourceAlpha" />
								<feComponentTransfer><feFuncA type="linear" slope="0.6" /></feComponentTransfer>
								<feBlend mode="normal" in2="SourceGraphic" />
							</filter> -->
							<linearGradient id="PSgrad_0" x1="0%" x2="48.481%" y1="87.462%" y2="0%">
								<stop offset="45%" stop-color="rgb(154,29,133)" stop-opacity="1" />
								<stop offset="100%" stop-color="rgb(180,98,198)" stop-opacity="1" />
							</linearGradient>
							<filter filterUnits="userSpaceOnUse" id="Filter_2" x="4px" y="4px" width="104px" height="104px">
								<feOffset in="SourceAlpha" dx="0" dy="0" />
								<feGaussianBlur result="blurOut" stdDeviation="2" />
								<feFlood flood-color="rgb(122, 14, 113)" result="floodOut" />
								<feComposite operator="atop" in="floodOut" in2="blurOut" />
								<feComponentTransfer><feFuncA type="linear" slope="0.36" /></feComponentTransfer>
								<feMerge>
									<feMergeNode />
									<feMergeNode in="SourceGraphic" />
								</feMerge>
							</filter>
						</defs>
						<g filter="url(#Filter_0)">
							<g filter="url(#Filter_1)">
								<path
									fill-rule="evenodd"
									fill="rgb(33, 33, 33)"
									d="M54.880,25.227 C71.348,25.227 84.698,38.577 84.698,55.046 C84.698,71.514 71.348,84.864 54.880,84.864 C38.412,84.864 25.061,71.514 25.061,55.046 C25.061,38.577 38.412,25.227 54.880,25.227 Z"
								/>
							</g>
						</g>
						<path
							fill="url(#PSgrad_0)"
							d="M54.880,25.227 C71.348,25.227 84.698,38.577 84.698,55.046 C84.698,71.514 71.348,84.864 54.880,84.864 C38.412,84.864 25.061,71.514 25.061,55.046 C25.061,38.577 38.412,25.227 54.880,25.227 Z"
						/>
						<g filter="url(#Filter_2)">
							<text
								kerning="auto"
								font-family="SimSun"
								fill="#ffffff"
								transform="matrix( 0.4969696969697, 0, 0, 0.4969696969697,35.6335878787879, 69.7777151515152)"
								font-size="20px"
							>
								<tspan font-size="20px" font-family="Source Han Sans SC" fill="#FFFFFF">&#24555;&#25463;&#23548;&#33322;</tspan>
							</text>
						</g>
						<path
							fill-rule="evenodd"
							fill="#ffffff"
							d="M63.466,44.242 L59.663,48.153 L55.859,44.242 C55.424,43.916 55.207,43.264 55.207,42.721 C55.207,42.179 55.424,41.634 55.859,41.200 L58.142,38.918 C59.010,38.049 60.424,38.049 61.183,38.918 L63.466,41.200 C63.901,41.636 64.118,42.179 64.118,42.721 C64.118,43.264 63.901,43.809 63.466,44.242 ZM62.704,41.960 L60.422,39.678 C60.205,39.461 59.989,39.351 59.663,39.351 C59.337,39.351 59.120,39.461 58.901,39.678 L56.621,41.960 C56.404,42.177 56.295,42.395 56.295,42.721 C56.295,43.048 56.404,43.264 56.621,43.483 L59.663,46.525 L62.704,43.483 C62.921,43.266 63.030,43.048 63.030,42.721 C63.030,42.395 62.921,42.179 62.704,41.960 ZM51.514,56.305 L48.253,56.305 C47.058,56.303 46.080,55.327 46.080,54.130 L46.080,50.869 C46.080,49.676 47.058,48.698 48.253,48.698 L53.687,48.698 L53.687,54.132 C53.687,55.327 52.708,56.305 51.514,56.305 ZM46.080,44.350 L46.080,41.089 C46.080,39.896 47.058,38.918 48.253,38.918 L51.514,38.918 C52.708,38.918 53.687,39.896 53.687,41.091 L53.687,46.525 L48.253,46.525 C47.058,46.525 46.080,45.547 46.080,44.350 ZM63.466,50.871 L63.466,54.132 C63.466,55.327 62.488,56.305 61.293,56.305 L58.032,56.305 C56.838,56.305 55.859,55.327 55.859,54.132 L55.859,48.698 L61.293,48.698 C62.488,48.698 63.466,49.676 63.466,50.871 Z"
						/>
					</svg>
				</template>
				<template v-else>
					<div class="closeBg" />
					<svg class="close" width="69px" height="69px" @click.stop="(open = false), shutDown()">
						<defs>
							<filter filterUnits="userSpaceOnUse" id="Filter_10" x="0px" y="0px" width="69px" height="69px">
								<feOffset in="SourceAlpha" dx="0" dy="0" />
								<feGaussianBlur result="blurOut" stdDeviation="3.606" />
								<feFlood flood-color="rgb(122, 14, 113)" result="floodOut" />
								<feComposite operator="atop" in="floodOut" in2="blurOut" />
								<feComponentTransfer><feFuncA type="linear" slope="0.4" /></feComponentTransfer>
								<feMerge>
									<feMergeNode />
									<feMergeNode in="SourceGraphic" />
								</feMerge>
							</filter>
							<filter id="Filter_11">
								<feOffset in="SourceAlpha" dx="-0.651" dy="1.891" />
								<feGaussianBlur result="blurOut" stdDeviation="3.606" />
								<feFlood flood-color="rgb(255, 255, 255)" result="floodOut" />
								<feComposite operator="out" in="floodOut" in2="blurOut" result="compOut" />
								<feComposite operator="in" in="compOut" in2="SourceAlpha" />
								<feComponentTransfer><feFuncA type="linear" slope="0.6" /></feComponentTransfer>
								<feBlend mode="normal" in2="SourceGraphic" />
							</filter>
						</defs>
						<g filter="url(#Filter_10)">
							<g filter="url(#Filter_11)">
								<path
									fill-rule="evenodd"
									fill="rgb(255, 255, 255)"
									d="M33.880,12.211 C45.939,12.211 55.714,21.987 55.714,34.046 C55.714,46.104 45.939,55.880 33.880,55.880 C21.821,55.880 12.045,46.104 12.045,34.046 C12.045,21.987 21.821,12.211 33.880,12.211 Z"
								/>
							</g>
						</g>
						<path
							fill-rule="evenodd"
							fill="rgb(153, 29, 133)"
							d="M35.463,34.157 L41.275,39.952 C41.676,40.352 41.676,41.000 41.275,41.400 C40.874,41.800 40.223,41.800 39.822,41.400 L34.010,35.606 L28.197,41.400 C27.796,41.800 27.145,41.800 26.744,41.400 C26.343,41.000 26.343,40.352 26.744,39.952 L32.556,34.157 L26.744,28.362 C26.343,27.962 26.343,27.314 26.744,26.914 C27.145,26.514 27.796,26.514 28.197,26.914 L34.010,32.708 L39.822,26.914 C40.223,26.514 40.874,26.514 41.275,26.914 C41.676,27.314 41.676,27.962 41.275,28.362 L35.463,34.157 Z"
						/>
					</svg>
					<div class="contactUs button" style="width: 55px; height: 55px" @click.stop="goAbout">
						<svg width="10px" height="16px">
							<path
								fill-rule="evenodd"
								fill="rgb(255, 255, 255)"
								d="M8.873,5.824 C8.671,6.321 8.233,6.893 7.574,7.520 C7.128,7.939 6.700,8.389 6.299,8.859 C5.964,9.260 5.711,9.618 5.530,9.950 C5.333,10.299 5.198,10.678 5.130,11.081 C5.079,11.402 5.054,11.753 5.054,12.124 C5.054,12.474 4.937,12.567 4.899,12.598 C4.738,12.727 4.543,12.787 4.282,12.787 C4.014,12.787 3.804,12.728 3.642,12.606 C3.527,12.520 3.510,12.266 3.510,12.122 C3.510,11.923 3.558,11.647 3.647,11.327 C3.899,10.457 4.288,9.636 4.803,8.887 C5.089,8.470 5.423,8.078 5.802,7.717 C6.131,7.389 6.416,7.083 6.646,6.808 C6.881,6.534 7.088,6.232 7.264,5.908 C7.414,5.621 7.528,5.316 7.599,5.002 C7.667,4.710 7.700,4.388 7.700,4.015 C7.700,2.996 7.364,2.269 6.701,1.852 C6.189,1.530 5.588,1.367 4.915,1.367 C4.873,1.367 4.830,1.368 4.792,1.369 C4.154,1.380 3.534,1.521 2.945,1.792 C2.223,2.138 1.808,2.778 1.808,3.548 C1.808,3.683 1.783,3.745 1.637,3.826 C1.364,3.981 1.105,4.056 0.855,4.056 C0.487,4.044 0.332,3.967 0.302,3.938 C0.281,3.916 0.212,3.826 0.212,3.540 C0.208,3.100 0.320,2.665 0.535,2.282 C0.766,1.873 1.090,1.512 1.470,1.237 C1.930,0.907 2.440,0.654 2.990,0.483 C3.579,0.291 4.225,0.187 4.914,0.172 C5.530,0.151 6.143,0.231 6.737,0.409 C7.228,0.556 7.690,0.813 8.072,1.152 C8.443,1.491 8.738,1.917 8.929,2.388 C9.136,2.882 9.233,3.476 9.219,4.155 C9.207,4.729 9.090,5.291 8.873,5.824 ZM3.616,14.371 C3.780,14.207 4.008,14.113 4.241,14.113 L4.283,14.114 L4.303,14.114 C4.307,14.113 4.311,14.113 4.315,14.113 C4.555,14.113 4.786,14.207 4.950,14.371 C5.134,14.555 5.212,14.754 5.212,15.039 C5.212,15.314 5.129,15.526 4.952,15.703 C4.774,15.880 4.561,15.962 4.283,15.962 C4.005,15.962 3.793,15.880 3.617,15.706 C3.438,15.526 3.354,15.314 3.354,15.039 C3.354,14.762 3.437,14.550 3.616,14.371 Z"
							/>
						</svg>
						<svg width="35px" height="9px">
							<text kerning="auto" font-family="SimSun" fill="rgb(255, 255, 255)" transform="matrix( 0.5, 0, 0, 0.5,0.2165, 7.7605)" font-size="18px">
								<tspan font-size="18px" font-family="Source Han Sans SC" fill="#FFFFFF">&#32852;&#31995;&#25105;&#20204;</tspan>
							</text>
						</svg>
					</div>
					<div class="download button" style="width: 55px; height: 55px" @click.stop="goDown">
						<svg width="15px" height="17px">
							<path
								fill-rule="evenodd"
								fill="rgb(255, 255, 255)"
								d="M13.922,8.730 L13.922,8.730 C13.613,8.418 13.109,8.419 12.800,8.730 L8.101,13.465 L8.101,0.971 C8.084,0.541 7.736,0.204 7.308,0.204 C6.880,0.204 6.532,0.541 6.515,0.972 L6.515,13.468 L1.813,8.732 C1.665,8.583 1.461,8.498 1.251,8.498 C1.182,8.498 1.113,8.507 1.047,8.525 C0.774,8.599 0.559,8.815 0.486,9.090 C0.413,9.364 0.492,9.660 0.692,9.861 L6.746,15.958 C6.893,16.107 7.098,16.192 7.307,16.192 C7.515,16.192 7.720,16.107 7.867,15.958 L13.923,9.860 C14.232,9.548 14.232,9.041 13.922,8.730 Z"
							/>
						</svg>
						<svg width="36px" height="9px">
							<text
								kerning="auto"
								font-family="SimSun"
								fill="rgb(255, 255, 255)"
								transform="matrix( 0.5, 0, 0, 0.50335570469799,0.40125, 8.07911073825503)"
								font-size="18px"
							>
								<tspan font-size="18px" font-family="Source Han Sans SC" fill="#FFFFFF">&#36164;&#26009;&#19979;&#36733;</tspan>
							</text>
						</svg>
					</div>
					<div class="sample button" style="width: 55px; height: 55px" @click.stop="goAdd">
						<svg width="15px" height="15px" v-if="!sample">
							<path
								fill-rule="evenodd"
								fill="rgb(255, 255, 255)"
								d="M14.357,8.143 L8.143,8.143 L8.143,14.357 C8.143,14.712 7.855,15.000 7.500,15.000 C7.145,15.000 6.857,14.712 6.857,14.357 L6.857,8.143 L0.643,8.143 C0.288,8.143 -0.000,7.855 -0.000,7.500 C-0.000,7.145 0.288,6.857 0.643,6.857 L6.857,6.857 L6.857,0.643 C6.857,0.288 7.145,-0.000 7.500,-0.000 C7.855,-0.000 8.143,0.288 8.143,0.643 L8.143,6.857 L14.357,6.857 C14.712,6.857 15.000,7.145 15.000,7.500 C15.000,7.855 14.712,8.143 14.357,8.143 Z"
							/>
						</svg>
						<svg v-else width="15px" height="19px">
							<image
								x="0px"
								y="0px"
								width="15px"
								height="19px"
								xlink:href="data:img/png;base64,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"
							/>
						</svg>
						<svg width="36px" height="9px">
							<text kerning="auto" font-family="SimSun" fill="rgb(0, 0, 0)" transform="matrix( 0.5, 0, 0, 0.5,0.364, 7.86625)" font-size="18px">
								<tspan v-if="!sample" font-size="18px" font-family="Source Han Sans SC" fill="#FFFFFF">&#26679;&#21697;&#30003;&#35831;</tspan>
								<tspan v-else font-size="18px" font-family="Source Han Sans SC" fill="#FFFFFF">&#30003;&#35831;&#35760;&#24405;</tspan>
							</text>
						</svg>
					</div>
				</template>
				<div class="showClick" style="width: 111px; height: 160px" v-if="!show" @click.stop="show = !show"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
export default {
	name: 'FloatBtn',
	props: {
		sample: false
	},
	data() {
		return {
			show: true,
			border_distance: 15, //可拖拽元素距离屏幕边界最小距离
			divWidth: 164 / 2, //可拖拽元素宽度
			divHeight: 164 / 2, //可拖拽元素高度
			moveLeft: document.documentElement.clientWidth - 164 / 2 - 15, //可拖拽元素距离屏幕左边界
			moveTop: document.documentElement.clientHeight - 30 - 164 / 2 - 15 - 120, //可拖拽元素距离屏幕上边界
			clientWidth: document.documentElement.clientWidth, //屏幕宽度
			clientHeight: document.documentElement.clientHeight - 30, //屏幕高度
			open: false
		};
	},
	mounted() {
		// console.log(this.clientWidth, this.clientHeight);
	},
	methods: {
		async goAbout() {
			this.shutDown();
			this.open = false;
			this.$dataStatistics({ event_type: 'click' }, '联系我们');
			// await this.scoreAdd();
			window.location.href = `https://landing-release.lookstar.com.cn/pages/5beb0ed9-015d-4c8e-971a-cc644396a8f7?appid=wxd0e450f42accad28&utm_campaign=3D%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC&utm_source=%E8%85%BE%E8%AE%AF`;
		},
		goApply() {
			this.shutDown();
			this.$dataStatistics({ event_type: 'click' }, '申请记录');
			localStorage.setItem('state', '');
			this.$router.push('/samplerecord');
		},
		goDown() {
			this.shutDown();
			this.$dataStatistics({ event_type: 'click' }, '资料下载');
			window.location.href = `https://cloud-app.lookstar.com.cn/data-download?tenant=6c3fa2b0-c5be-471d-8c73-4a831e22aea9&project=1499&appid=wxd0e450f42accad28&utm_campaign=3d&utm_source=%E8%85%BE%E8%AE%AF`;
		},
		goAdd() {
			if (this.sample) {
				this.goApply();
			} else {
				this.shutDown();
				this.$dataStatistics({ event_type: 'click' }, '样品申请');
				this.$router.push('/sample');
			}
		},
		shutDown() {
			// this.show = false;
		},
		scoreAdd(item, index) {
			return new Promise((resolve, reject) => {
				//加积分
				let data = {
					source: '联系我们',
					type: 6
				};
				this.$http
					.post('/api/platform/user/score', data)
					.then((res) => {
						console.log('res', res);
						if (res?.data?.errcode) {
							reject();
						}
						resolve();
					})
					.catch((err) => {
						reject();
					});
			});
		},
		dragStart(e) {
			this.$refs.point.style.transition = 'none';
		},
		dragEnd(e) {
			this.$refs.point.style.transition = 'all 0.3s';
			// if (this.moveLeft > this.clientWidth / 2) {
			// 	//若移动位于屏幕的左边或右边，则自动贴合左边或右边（此根据业务具体需求表现而定）
			// 	this.moveLeft = this.clientWidth - this.divWidth - this.border_distance;
			// } else {
			// 	this.moveLeft = this.border_distance;
			// }
			this.moveLeft = this.clientWidth - this.divWidth - this.border_distance; //右侧自动贴边

			if (this.moveTop < 0) {
				this.moveTop = this.border_distance;
			} else if (this.moveTop + 164 / 2 > this.clientHeight) {
				this.moveTop = this.clientHeight - 164 / 2 - this.border_distance;
			}
		},
		dragMove(e) {
			if (e.touches.length) {
				let touch = e.touches[0];
				this.moveLeft = touch.clientX - this.divWidth / 2; //因拖动的中间点为Dom节点的中心点，所以left需减去Dom节点一半的宽度
				this.moveTop = touch.clientY - this.divHeight / 2; //top原理同上
			}
		}
	}
};
</script>

<style lang="less" scoped>
.point {
	position: fixed;
	z-index: 999;
	text-align: right;
	width: auto;
	height: auto;
	transform: translateX(38%) scale(0.9);

	&.show {
		transform: translateX(0) scale(0.9);
	}
}

.flexBox {
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: visible;
	visibility: visible;
	position: relative;

	& .showClick {
		position: absolute;
		z-index: 99;
		left: 0;
		top: 0;
	}

	& * {
		overflow: visible;
		visibility: visible;
	}

	.aiBtn {
		width: 165px;
		height: 165px;
		position: absolute;
		z-index: 3;
		top: 165px;
		left: 35px;
	}

	.close {
		position: relative;
		z-index: 1;
		border-radius: 100%;
		&::after {
			content: '';
			display: block;
			width: 40px;
			height: 40px;
			position: absolute;
			z-index: 1;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: #fff;
		}
	}

	.closeBg {
		z-index: 0;
		border-radius: 100%;
		width: 92px;
		height: 92px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-52%, -52%);
		background-color: #fff;
		box-shadow: 0 0 24px 6px rgba(122, 14, 113, 0.14);
	}

	.button {
		background-color: @theme;
		box-shadow: 0 0 24px 6px rgba(0, 0, 0, 0.14);
		border-radius: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		align-content: center;
		flex-direction: column;

		svg {
			padding: 6px 0;
			display: block;
			box-sizing: content-box;
		}
	}

	.contactUs {
		position: absolute;
		top: -70px;
		left: 60px;
		z-index: 2;
	}

	.download {
		position: absolute;
		top: 55px;
		left: -70px;
		z-index: 2;
	}

	.sample {
		position: absolute;
		top: 185px;
		left: 60px;
		z-index: 2;
	}
}

.backIcon {
	width: 104px;
	display: inline-block;
	margin-bottom: 22px;
}

.homeIcon {
	// width: 126px;
	// height: 132px;
	width: 104px;
	display: inline-block;
}

.aboutIcon {
	margin-top: -50px;
	width: 150px;
	height: 177px;
	display: inline-block;
	position: relative;
	z-index: 11;
}
</style>
